import {
  commentType,
  CreateCommentInput,
  CreateCommentMutation,
  CreateCommentMutationVariables,
  GetCommentsQuery,
  GetCommentsQueryVariables,
  mediaSource,
} from 'API';
import { API } from 'aws-amplify';
import { createComment } from 'graphql/mutations';
import { getComments } from 'graphql/queries';
import { KPIvalues } from '../CustomReportKPI';
import { useCustomReportContext } from 'context/CustomReportContext';

export const useGetSavedText = (): readonly [(position: string) => Promise<string | null>] => {
  const { activeCustomReport } = useCustomReportContext();
  const fetchCustomReportText = async (position: string) => {
    try {
      const response = (await API.graphql({
        query: getComments,
        variables: {
          campaign: activeCustomReport?.CustomReportID,
          sub_campaign: -1,
          media_source: mediaSource.OVERALL,
          comment_type: commentType.COMMENT,
          placeholder: position,
        } as GetCommentsQueryVariables,
        authMode: 'AMAZON_COGNITO_USER_POOLS',
      })) as { data: GetCommentsQuery };
      const { data } = response;
      const list = data.getComments;
      const findNewestComment =
        list && list.length > 0
          ? list.reduce(
              (prev, current) => {
                if (!prev) return current;
                if (!current) return prev;
                return prev.created_at > current.created_at ? prev : current;
              },
              null as (typeof list)[0] | null,
            )
          : null;

      return findNewestComment?.comment as string;
    } catch (e) {
      console.error(e);
      return null;
    }
  };
  return [fetchCustomReportText];
};

export const useSaveCustomReportText = (): readonly [
  (
    position: string,
    comment: string,
    customReportId?: number,
    clientInfo?: { code: string; country: string },
  ) => Promise<string>,
] => {
  const { activeCustomReport } = useCustomReportContext();
  const saveCustomReportText = async (
    position: string,
    comment: string,
    customReportId?: number,
    clientInfo?: { code: string; country: string },
  ) => {
    const idToUse = customReportId || activeCustomReport?.CustomReportID;
    const clientToUse =
      clientInfo ||
      (activeCustomReport?.Client
        ? { code: activeCustomReport.Client.Code || '', country: activeCustomReport.Client.Country || '' }
        : undefined);
    try {
      const response = (await API.graphql({
        query: createComment,
        variables: {
          comment: {
            campaign: idToUse,
            sub_campaign: -1,
            client: clientToUse,
            media_source: mediaSource.OVERALL,
            comment_type: commentType.COMMENT,
            comment: comment,
            placeholder: position,
          } as CreateCommentInput,
        } as CreateCommentMutationVariables,
        authMode: 'AMAZON_COGNITO_USER_POOLS',
      })) as { data: CreateCommentMutation };
      const r = response.data.createComment;
      if (r) {
        if (r.statusCode === 200) {
          return 'success';
        } else {
          return 'error';
        }
      } else {
        return 'error';
      }
    } catch (e) {
      console.log('ERROR SAVING CUSTOM REPORT TEXT', e);
      return 'ERROR SAVING CUSTOM REPORT TEXT';
    }
  };
  return [saveCustomReportText];
};
